import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IChangeRecord } from "../../components/ChangeHistoryTimeline/ChangeHistoryTimeline.types";
import { endPoints } from "../../constants/endPoints";
import { APIError } from "../../constants/types";
import { IFetchChangeHistoryParams } from "./changeHistory.types";

export const fetchChangeHistoryAsync = createAsyncThunk<
  IChangeRecord[],
  IFetchChangeHistoryParams,
  { rejectValue: APIError }
>(
  "changeHistory/fetchChangeHistory",
  async (params, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.set("module_name", params.module_name);
      if (params.entry_id) queryParams.set("entry_id", params.entry_id);
      if (params.user_fact_id)
        queryParams.set("user_fact_id", params.user_fact_id);
      if (params.action) queryParams.set("action", params.action);
      if (params.from_date) queryParams.set("from_date", params.from_date);
      if (params.to_date) queryParams.set("to_date", params.to_date);

      const res = await api.get(
        `${endPoints.changeHistory.fetchChangeHistory}?${queryParams.toString()}`,
      );
      return res.data.data as IChangeRecord[];
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || { message: "Network error" },
      );
    }
  },
);
